import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import isEmpty from 'lodash/isEmpty';

/**
 * Returns a filtered object with only the properties that are not empty strings
 *
 * @param {Object} v
 * @returns {Object}
 */
export function removeEmptyStrings(obj) {
    const newObj = Array.isArray(obj) ? [] : {};

    Object.entries(obj).forEach(([key, value]) => {
        if (isObject(value)) {
            const child = removeEmptyStrings(value);
            if (!Array.isArray(child) || !isEmpty(child)) {
                newObj[`${key}`] = child;
            }
        } else if (isString(value)) {
            if (value.trim() !== '') {
                newObj[`${key}`] = value;
            }
        } else {
            newObj[`${key}`] = value;
        }
    });

    return newObj;
}

export default removeEmptyStrings;
